<div class="dialog-content-wrapper google-map-container">
  <!-- CONTENT -->

  <div class="content px-16 relative">
    <i
      type="button"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="closeDialog()"
      class="color-4 far fa-times-circle absolute top-[-20px] right-[-20px] m-3"
      style="font-size: 16px"
      #closebutton
    ></i>
    <div mat-dialog-content class="p-0 m-0">
      <p fxLayout="row" fxLayoutAlign="start start">
        @if (mapsApiLoaded) {
          <google-map
            [center]="{ lat: lat, lng: lng }"
            [zoom]="zoom"
            [width]="'100%'"
            [height]="mapHeight"
            [options]="{ disableDefaultUI: false, zoomControl: true }"
            (mapClick)="mapClicked($event)"
          >
            @if (markerLat != null && markerLng != null) {
              <map-marker
                [position]="{ lat: markerLat, lng: markerLng }"
                [options]="{ draggable: true }"
              >
              </map-marker>
            }
          </google-map>
        }
      </p>
    </div>
  </div>
  <div
    mat-dialog-actions
    class="m-0 pt-0"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    @if (_data?.showButton) {
      <div
        class="nav-link btn btn-1 m-2"
        (click)="matDialogRef.close([address, compAddress, coordinates])"
      >
        {{ 'Pick Address' }}
      </div>
    }
  </div>
</div>
